// Per-website differences of the header that css alone cannot express. The
// colours live in src/themes/*.scss (--hrra-chrome-* properties).

// Partner sites have no apps launcher (the 3x3 dot site switcher left of the logo).
const THEMES_WITHOUT_APPS_LAUNCHER = ['cv', 'doctor', 'chefs'];

// The favourites link icon - a heart unless the site's design says otherwise.
const FAVORITES_ICONS: { [theme: string]: string } = {
  cv: 'assets/icons/header-2-star.svg',
  doctor: 'assets/icons/header-2-cross.svg',
};

export function hasAppsLauncher(theme: string): boolean {
  return !THEMES_WITHOUT_APPS_LAUNCHER.includes(theme);
}

export function getFavoritesIcon(theme: string): string {
  return FAVORITES_ICONS[theme] ?? 'assets/icons/header-2-heart.svg';
}
